import moment from 'moment-timezone';

export const getTimeZone = () => {
  let timeZone = moment().tz(moment.tz.guess()).zoneAbbr();
  const needGMT = timeZone.indexOf('+') !== -1 || timeZone.indexOf('-') !== -1;

  if (needGMT) {
    timeZone = `GMT${timeZone}`;
  }

  return timeZone;
}
